export enum ActivityType {
  DRILLING = 'DRILLING',
  TRIPPING = 'TRIPPING',
  CASING = 'CASING',
}

export type Connection = {
  activity_type: ActivityType;
  activity_target_best: number | null;
  connection_target_best: number | null;
  activity_target_avg: number | null;
  connection_target_avg: number | null;
  activity_target_bcw: number | null;
  connection_target_bcw: number | null;
  stands: Stand[];
};

export type EnrichedConnection = Connection & { maxValueP90?: number };

export const defaultConnection = (activityType: ActivityType): Connection => ({
  activity_type: activityType,
  activity_target_best: null,
  connection_target_best: null,
  activity_target_avg: null,
  connection_target_avg: null,
  activity_target_bcw: null,
  connection_target_bcw: null,
  stands: [],
});

type Stand = {
  stand_id: number;
  activity_duration: number;
  connection_duration: number;
  stand_length: number;
  start_time: string;
  end_time: string;
  speed: number;
  start_depth: number;
  end_depth: number | null;
  is_open_hole: boolean;
};
